module.exports = __webpack_public_path__ + "img/lsetf.983c74f7.png";